import { InjectionToken } from '@angular/core';

export const CRYPTO = new InjectionToken<Crypto>('Crypto API', {
    providedIn: 'root',
    factory: () => crypto
});
